import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import { ProgramPlusCard, ProgramPlusCardStyles } from './ProgramPlusCard';
import { ProgramFilters, applyProgramFilters, emptyFilters } from './ProgramFilters';
dayjs.locale('th');

export class ProgramPlus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            programs: [],
            continents: [],
            countries: [],
            regions: [],
            provinces: [],
            loading: true,
            filters: { ...emptyFilters },
            view: 'grid'
        };
    }

    componentDidMount() { this.load(); }

    load() {
        this.setState({ loading: true });
        Promise.all([
            fetch('api/programplus?includeInactive=1').then(r => r.ok ? r.json() : []),
            fetch('api/programplus/continents/master').then(r => r.ok ? r.json() : []),
            fetch('api/programplus/countries/master').then(r => r.ok ? r.json() : []),
            fetch('api/programplus/regions/master').then(r => r.ok ? r.json() : []),
            fetch('api/programplus/provinces/master').then(r => r.ok ? r.json() : [])
        ]).then(([programs, continents, countries, regions, provinces]) => {
            this.setState({ programs, continents, countries, regions, provinces, loading: false });
        }).catch(() => this.setState({ loading: false }));
    }

    deleteProgram(p) {
        if (!window.confirm('ต้องการลบ "' + p.name + '" หรือไม่?')) return;
        fetch('api/programplus/' + p.id, { method: 'DELETE', headers: { 'X-User-Username': localStorage.getItem('username') || '', 'X-User-Display-Name': localStorage.getItem('displayName') || '' } })
            .then(r => { if (r.ok) this.load(); })
            .catch(() => {});
    }

    getFiltered() {
        return applyProgramFilters(this.state.programs, this.state.filters, this.state.countries, this.state.provinces);
    }

    renderCard(p) {
        var inactive = p.isActive === 0;
        return (
            <div key={p.id} className="col-md-6 col-lg-4 mb-4">
                <div style={{ position:'relative', opacity: inactive?0.6:1, filter: inactive?'grayscale(0.3)':'none' }}>
                    {inactive && (
                        <span style={{ position:'absolute', top:8, left:8, zIndex:2, background:'#6c757d', color:'#fff', padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600 }}>
                            <i className="fas fa-pause-circle"></i> Inactive
                        </span>
                    )}
                    <span style={{ position:'absolute', top:8, right:8, zIndex:2, background:'rgba(0,0,0,0.7)', color:'#fff', padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600 }}>
                        <i className="fas fa-eye"></i> {Number(p.viewCount||0).toLocaleString()}
                    </span>
                    <ProgramPlusCard p={p} showActions onDelete={() => this.deleteProgram(p)} />
                </div>
            </div>
        );
    }

    renderTable(list) {
        return (
            <div className="table-responsive">
                <table className="table table-hover" style={{ fontSize: 14 }}>
                    <thead style={{ background: '#f8f9fa' }}>
                        <tr>
                            <th style={{ width: 50 }}>#</th>
                            <th style={{ width: 70 }}>ภาพ</th>
                            <th style={{ width: 90 }}>รหัส</th>
                            <th>ชื่อโปรแกรม</th>
                            <th style={{ width: 70, textAlign: 'center' }}>วัน/คืน</th>
                            <th style={{ width: 110 }}>สายการบิน</th>
                            <th style={{ width: 110 }}>เดินทาง</th>
                            <th style={{ width: 100, textAlign: 'right' }}>ราคา</th>
                            <th style={{ width: 80, textAlign: 'center' }}>View</th>
                            <th style={{ width: 90, textAlign: 'center' }}>จัดการ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((p, i) => (
                            <tr key={p.id}>
                                <td style={{ color: '#aaa' }}>{i + 1}</td>
                                <td><img src={p.coverImg || '/images/importClick.png'} alt="" style={{ width: 56, height: 36, objectFit: 'cover', borderRadius: 4 }} /></td>
                                <td><span className="badge" style={{ background: '#dc3545' }}>{p.code}</span></td>
                                <td>
                                    <div style={{ fontWeight: 600, fontSize: 13 }}>{p.name}</div>
                                    {p.destinations && <div style={{ color: '#999', fontSize: 11 }}>{p.destinations}</div>}
                                </td>
                                <td style={{ textAlign: 'center' }}>{p.days}D{p.nights}N</td>
                                <td>
                                    {p.airlineLogo && <img src={p.airlineLogo} alt="" style={{ height: 16, marginRight: 4 }} />}
                                    <span style={{ fontSize: 12 }}>{p.airlineName}</span>
                                </td>
                                <td style={{ fontSize: 12 }}>{p.soonStart ? dayjs(p.soonStart).format('D MMM YY') : '-'}</td>
                                <td style={{ textAlign: 'right', fontWeight: 700, color: '#dc3545' }}>{p.startPrice > 0 ? Number(p.startPrice).toLocaleString() + '.-' : '-'}</td>
                                <td style={{ textAlign: 'center' }}><i className="fas fa-eye" style={{ color:'#888', marginRight:4 }}></i>{Number(p.viewCount||0).toLocaleString()}</td>
                                <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                                    <Link to={'/console/programplus/view/' + p.id} className="btn btn-outline-success btn-sm" style={{ marginRight: 4, padding: '2px 6px' }}><i className="fas fa-eye"></i></Link>
                                    <Link to={'/console/programplus/edit/' + p.id} className="btn btn-outline-primary btn-sm" style={{ marginRight: 4, padding: '2px 6px' }}><i className="fas fa-edit"></i></Link>
                                    <button className="btn btn-outline-danger btn-sm" style={{ padding: '2px 6px' }} onClick={() => this.deleteProgram(p)}><i className="fas fa-trash"></i></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        const { loading, view, filters, continents, countries, regions, provinces } = this.state;
        var filtered = this.getFiltered();
        var hasFilter = filters.selectedContinent > 0 || filters.selectedCountry > 0 || filters.selectedRegion > 0 || filters.selectedProvince > 0 || (filters.hashtags||[]).length > 0 || (filters.keyword||'').trim();

        return (
            <div style={{ padding: 20 }}>
                <ProgramPlusCardStyles />
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>จัดการโปรแกรมทัวร์ {filtered.length} รายการ</p>
                    <Link to="/console/programplus/create" className="btn btn-danger" style={{ borderRadius: 8 }}>
                        <i className="fas fa-plus"></i> สร้างโปรแกรมใหม่
                    </Link>
                </div>

                <ProgramFilters filters={filters} onChange={f => this.setState({ filters: f })}
                    continents={continents} countries={countries} regions={regions} provinces={provinces} />

                <div className="d-flex justify-content-end align-items-center mb-3">
                    <div className="btn-group">
                        <button className={'btn btn-sm ' + (view === 'grid' ? 'btn-dark' : 'btn-outline-dark')} onClick={() => this.setState({ view: 'grid' })}><i className="fas fa-th"></i></button>
                        <button className={'btn btn-sm ' + (view === 'table' ? 'btn-dark' : 'btn-outline-dark')} onClick={() => this.setState({ view: 'table' })}><i className="fas fa-list"></i></button>
                    </div>
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-danger"></div><div className="mt-2" style={{ color: '#999' }}>กำลังโหลด...</div></div>
                ) : filtered.length === 0 ? (
                    <div className="text-center py-5" style={{ color: '#bbb' }}>
                        <i className="fas fa-inbox" style={{ fontSize: 48, display: 'block', marginBottom: 12 }}></i>
                        {hasFilter ? 'ไม่พบรายการที่ค้นหา' : 'ยังไม่มีโปรแกรมทัวร์'}
                        {!hasFilter && <div className="mt-3"><Link to="/console/programplus/create" className="btn btn-outline-danger"><i className="fas fa-plus"></i> สร้างโปรแกรมแรก</Link></div>}
                    </div>
                ) : view === 'grid' ? (
                    <div className="row">{filtered.map(p => this.renderCard(p))}</div>
                ) : this.renderTable(filtered)}
            </div>
        );
    }
}
